import type { ClientPropertyCottageDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { mapPropertyToBuildingForm } from "web_myplann/Portfolio/Forms/BuildingShared/mapPropertyToBuildingForm";
import type { CottageFormInput } from "web_myplann/Portfolio/Forms/CottageForm/cottageFormSchema";

export const mapPropertyToCottageForm = (
	property: ClientPropertyCottageDetailResponseDTO,
): CottageFormInput =>
	mapPropertyToBuildingForm(property, property.numberOfFloors);
